(() => {
  const money = cents => new Intl.NumberFormat('de-DE', {style:'currency',currency:'EUR'}).format(cents / 100);
  function sync() {
    const plans = document.getElementById('MbRentalPlans');
    const form = document.getElementById('MbRentalRequestForm');
    if (!plans || !form) return;
    const allowedMonths = (plans.dataset.rentalMonths || '12,24').split(',').map(Number);
    let selected = plans.querySelector('input:checked');
    if (allowedMonths.length === 1 && allowedMonths[0] === 12) {
      selected = plans.querySelector('input[value="12"]');
      if (selected) selected.checked = true;
    }
    if (!selected) return;
    const months = Number(selected.value), rate = Number(selected.dataset.rate), total = Number(selected.dataset.total);
    if (!allowedMonths.includes(months) || rate <= 0 || total !== rate * months) return;
    const terms = `${months} gleiche Mieten à ${money(rate)}. Gesamtbetrag: ${money(total)}. Nach Zahlung der ${months}. Miete darf das Gerät behalten werden. 24 Monate Garantie ab Lieferung.`;
    const fields = {MbRentalMonths:months, MbRentalMonthly:money(rate), MbRentalTotal:money(total), MbRentalTerms:terms, MbRentalWarranty:'24 Monate ab Lieferung', MbRentalVariant:plans.dataset.variantId};
    for (const [id,value] of Object.entries(fields)) { const el=document.getElementById(id); if(el) el.value=value; }
    const summary=document.getElementById('MbSelectedRentalTerms');
    if(summary) summary.textContent=terms;
    const eligibility=document.getElementById('MbCustomerEligibility');
    const confirmation=document.getElementById('MbExistingCustomer');
    if(eligibility && confirmation){
      const needed=eligibility.dataset.alwaysRequired==='true' || total>100000;
      eligibility.hidden=!needed;
      confirmation.required=needed;
      confirmation.disabled=!needed;
      if(!needed) confirmation.checked=false;
    }
    form.dataset.rentalMonths=months; form.dataset.rentalRate=rate; form.dataset.rentalTotal=total;
  }
  window.mbSyncRentalEligibility=sync;
  document.addEventListener('change', e => {if(e.target.matches('#MbRentalPlans input')) sync();});
  document.addEventListener('submit', e => {if(e.target.id==='MbRentalRequestForm') sync();}, true);
  document.addEventListener('shopify:section:load',sync);
  window.addEventListener('pageshow',sync);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',sync); else sync();
  // Product variants/sections can be replaced by the theme without a page navigation.
  const observer=new MutationObserver(records=>{if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1 && (n.id==='MbRentalPlans'||n.querySelector?.('#MbRentalPlans'))))) sync();});
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
